jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false; // Enable or disable log 0/1/2

	// Copy to page - all options:
	// # INIT
	// var popover_enable = true; // Enable or disable function (Bootstrap)
	// var tooltip_enable = true; // Enable or disable function (Bootstrap)
	// var aos_enable = true; // Enable or disable function (Extra)

	popover_enable = (typeof popover_enable !== 'undefined')? popover_enable : true; // Enable or disable function (Bootstrap)
	tooltip_enable = (typeof tooltip_enable !== 'undefined')? tooltip_enable : true; // Enable or disable function (Bootstrap)
	aos_enable = (typeof aos_enable !== 'undefined')? aos_enable : false; // Enable or disable function (Extra)


	if(logit) console.log('[INIT] Started');

	// Enable Bootstrap Popovers
	if(popover_enable) {
		if(logit == 2) console.log('[INIT] Popover Enabled');
		$(function () {
			const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
	    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
		});
	} else {
		if(logit == 3) console.log('[INIT] Popover Disabled');
	}

	if(tooltip_enable) {
		if(logit == 2) console.log('[INIT] Tooltip Enabled');
		$(function () {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
			const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
		});
	} else {
		if(logit == 3) console.log('[INIT] Tooltip Disabled');
	}

	// AOS
	if(aos_enable) {
		AOS.init();
		if(logit == 2) console.log('[INIT] AOS Enabled');
	} else {
		if(logit == 3) console.log('[INIT] AOS Disabled');
	}

	// END JQUERY
});
